module.exports = __webpack_public_path__ + "img/solution3.8977234f.jpg";